export function capitalize(str: string): string {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function capitalizeFirstCharOnly(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const truncateText = (text: string, charCount: number) => {
  if (text.length <= charCount) {
    return text;
  }

  const truncatedText = text.substring(0, charCount);
  const lastSpaceIndex = truncatedText.lastIndexOf(" ");

  return lastSpaceIndex === -1
    ? truncatedText
    : truncatedText.substring(0, lastSpaceIndex);
};

export function removeNewlinesAndTabs(str: string) {
  str = str.replace(/\u00a0/g, " ");
  return str.replace(/[\n\t]/g, "");
}

export const truncateWords = (text: string, wordCount: number): string => {
  return text
    .split(/\s+/) // split by spaces
    .slice(0, wordCount || 100) // take first 100 words
    .join(" "); // join back into a string
};

export function countWords(text: string): number {
  const trimmedText = text.trim();
  if (!trimmedText) return 0;

  return trimmedText.split(/\s+/).length;
}
